<template>
  <div class="header" style="background:#fff;" :style="'background:'+BgCss">

    <div class="container33 theme-showcase" v-if="(topimg != '' && topimg != null)">
      <img :src="topimg" style="max-width: 100%; display:block; margin:0 auto;" :style="topimgWidth==0?'width:100%;':('width:'+topimgWidth+'px;')" />
      
    </div>

    <div v-if="mode==1" style="display:flex; text-align:center; background:#cce6ff; margin:12px auto; " :style="'max-width:100%; width:'+FormWidth+'px;'">
      <div style="flex:1; padding:2px 0; color:#fff; background:#23468c;">1.Registration Profile</div>
      <div style="flex:1;  padding:2px 0; ">2.Confirmation</div>
    </div>

    <div v-if="mode==2" style="display:flex; text-align:center; background:#cce6ff; margin:12px auto; " :style="'max-width:100%; width:'+FormWidth+'px;'">
      <div style="flex:1; padding:2px 0; color:#fff; background:#23468c;">1.Registration Profile</div>
      <div style="flex:1;  padding:2px 0; ">2.Payment</div>
      <div style="flex:1;  padding:2px 0; ">3.Confirmation</div>
    </div>

    <div class="container11 theme-showcase"  :style="'max-width:100%; width:'+FormWidth+'px; margin-top:'+ FormMarginTop+'px; margin-bottom:'+ FormMarginBtm+'px;'">

      <el-form ref="form" label-width="80px" label-position="top">

        <div v-for="(item, index) in fieldlist" :key="item.id" class="fdItem" :class="vallist[index].halfWidth?'fdItem2':''" :style="item.FieldTypeID==10?'width: 100%; margin: 0;':''">
          <div v-if="vallist[index].showFd">
            <div v-html="item.GroupHeader"></div>
            <div class="fieldLabel" v-if="!item.HideLabel && item.FieldTypeID!=10"><span v-if="item.IsCompulsory" style="color:red;">*</span>{{ item.FieldName }}</div>
            <div v-if="item.FieldTypeID!=10" style="font-size: 12px; color:gray; font-style: italic; margin-top: -8px; margin-bottom: 16px; ">{{
              item.Note }}</div>

            <div v-if="item.FieldTypeID == 1">
              <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                <el-input v-model="vallist[index].val" :placeholder="item.Hint" clearable :readonly="item.IsReadOnly"
                  :type="item.TextMode" :maxlength="item.MaxLength" @input="inputChange(index)"
                  @blur="inputBlur(index)"></el-input>
              </el-form-item>
            </div>

            <div v-if="item.FieldTypeID == 2">
              <div style="display: flex;">
                <div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                    <el-select v-model="vallist[index].val" :placeholder="item.Hint" clearable
                      @change="selectChange(index)" :allow-create="!item.IsLimitedInList"
                      filterable>
                      <el-option v-for="oitem in item.LookupValuesArr" :key="oitem.txt" :label="oitem.txt"
                        :value="oitem.txt">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="item.ShowOther" :style="item.ShowOther ? 'margin-left:16px;' : ''"
                  class="fieldLabel otherFieldLabel">
                  <div style="line-height:26px;" v-if="!item.HideLabel">{{ item.CustomTextPompt }}</div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredOtherErrMsg">
                    <el-input v-model="vallist[index].otherVal" :placeholder="item.CustomTextPompt" clearable
                      @input="inputOtherChange(index)"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div v-if="item.FieldTypeID == 3">


              <div style="">
                <div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                    <el-checkbox-group v-model="vallist[index].valArr" :max="item.MaxLength"
                      @change="checkboxChange(index)">
                      <div class="elCheckboxItem" :class="'elCheckboxItem' + item.Layout"
                        v-for="oitem in item.LookupValuesArr" :key="oitem.txt">
                        <el-checkbox :label="oitem.txt" :name="oitem.txt"></el-checkbox>
                      </div>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
                <div v-if="item.ShowOther" :style="item.ShowOther ? 'margin-left:16px;' : ''"
                  class="fieldLabel otherFieldLabel">
                  <div style="line-height:26px;" v-if="!item.HideLabel">{{ item.CustomTextPompt }}</div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredOtherErrMsg">
                    <el-input v-model="vallist[index].otherVal" :placeholder="item.CustomTextPompt" clearable
                      @input="inputOtherChange(index)"></el-input>
                  </el-form-item>
                </div>
              </div>

            </div>

            <div v-if="item.FieldTypeID == 4">


              <div>
                <div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                    <div :class="'elRadioItem' + item.Layout" class="elRadioItem" v-for="oitem in item.LookupValuesArr"
                      :key="oitem.txt">
                      <el-radio v-model="vallist[index].val" :label="oitem.txt" :name="oitem.txt"
                        @input="radioChange(index)"></el-radio>
                    </div>
                  </el-form-item>
                </div>
                <div v-if="item.ShowOther" :style="item.ShowOther ? 'margin-left:16px;' : ''"
                  class="fieldLabel otherFieldLabel">
                  <div style="line-height:26px;" v-if="!item.HideLabel">{{ item.CustomTextPompt }}</div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredOtherErrMsg">
                    <el-input v-model="vallist[index].otherVal" :placeholder="item.CustomTextPompt" clearable
                      @input="inputOtherChange(index)"></el-input>
                  </el-form-item>
                </div>
              </div>

            </div>

            <div v-if="item.FieldTypeID == 5">
              <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                <div style="display: flex; align-items:center;">
                  <div>
                    <el-upload class="avatar-uploader" action="#" :http-request="imgUpload" :show-file-list="false"
                      :data="{ index: index }">
                      <img v-if="vallist[index].imgUrl != '' && vallist[index].imgUrl != undefined"
                        :src="vallist[index].imgUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </div>
                  <div style="margin-left: 22px;">
                    <el-button v-if="vallist[index].imgUrl != '' && vallist[index].imgUrl != undefined"
                      @click="delimg(index)" type="danger" icon="el-icon-delete" circle></el-button>
                  </div>
                </div>
              </el-form-item>
            </div>

            <div v-if="item.FieldTypeID == 6">
              <div v-if="item.PhoneCodeModel==2">
                <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                  <div style="display: flex; align-items: center;">
                    <div style="width: 100px;"><el-input type="number" v-model="vallist[index].val" placeholder="" clearable
                        @input="inputChange2(index)" maxlength="5" max="99999"></el-input></div>
                    <div style="margin: 0 6px;">-</div>
                    <div><el-input v-model="vallist[index].val2" :placeholder="item.Hint" clearable
                        @input="inputChange2(index)" :maxlength="item.MaxLength" @blur="inputBlur(index)"></el-input></div>
                  </div>
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                  <div style="display: flex; align-items: center;">
                    <el-select v-model="vallist[index].val" :placeholder="item.Hint" style="width:150px;" 
                      @change="selectChange(index)" :allow-create="false" filterable :filter-method="countryFilterMethod" @visible-change="SelectVisible">
                      <el-option v-for="oitem in countryCodes" :key="oitem.name" :label="'+'+oitem.code"
                        :value="oitem.code">
                        <span style="float: left">{{ oitem.name+'(+'+oitem.code+')' }}</span>
                      </el-option>
                    </el-select>
                  <div style="margin: 0 6px;">-</div>
                  <div><el-input v-model="vallist[index].val2" :placeholder="item.Hint" clearable
                      @input="inputChange2(index)" :maxlength="item.MaxLength" @blur="inputBlur(index)"></el-input></div>
                </div>
                    
                  </el-form-item>
              </div>
            </div>

            <div v-if="item.FieldTypeID == 7">
              <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                <el-date-picker v-model="vallist[index].val" type="date" :placeholder="item.Hint"
                  :picker-options="datePickerOptions" @focus="datepickerFocus(index)" @change="datepickerChange(index)">
                </el-date-picker>
              </el-form-item>
            </div>

            <div v-if="item.FieldTypeID == 8">
              <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                <el-time-picker v-model="vallist[index].val" :placeholder="item.Hint" @change="timepickerChange(index)" value-format="HH:mm" format="HH:mm">
                </el-time-picker>
              </el-form-item>
            </div>

            <div v-if="item.FieldTypeID == 9">

            </div>

            <div v-if="item.FieldTypeID == 10">
              <div v-html="item.StaticHtml"></div>
            </div>

            <div v-if="item.FieldTypeID == 11">
              <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                <el-date-picker v-model="vallist[index].val" type="month" @change="monthpickerChange(index)">
                </el-date-picker>
              </el-form-item>
            </div>

            <div v-if="item.FieldTypeID == 12">
              <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                <el-input-number v-model="vallist[index].val" @input="inputNumberChange(index)" :max="item.MaxValue"
                  :min="item.MinValue"></el-input-number>
              </el-form-item>
            </div>

            <div v-if="item.FieldTypeID == 13">


              <div style="display: flex;">
                <div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredErrMsg">
                    <el-select v-model="vallist[index].valArr" multiple collapse-tags style="" :placeholder="item.Hint"
                      clearable :multiple-limit="item.MaxLength" :allow-create="!item.IsLimitedInList"
                      filterable @change="selectMultipleChange(index)">
                      <el-option v-for="oitem in item.LookupValuesArr" :key="oitem.txt" :label="oitem.txt"
                        :value="oitem.txt">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="item.ShowOther" :style="item.ShowOther ? 'margin-left:16px;' : ''"
                  class="fieldLabel otherFieldLabel">
                  <div style="line-height:26px;" v-if="!item.HideLabel">{{ item.CustomTextPompt }}</div>
                  <el-form-item :required="item.IsCompulsory" :error="vallist[index].requiredOtherErrMsg">
                    <el-input v-model="vallist[index].otherVal" :placeholder="item.CustomTextPompt" clearable
                      @input="inputOtherChange(index)"></el-input>
                  </el-form-item>
                </div>
              </div>

            </div>
            <div v-html="item.GroupFooter"></div>
          </div>
        </div>

        <div style="text-align:center; padding-bottom:2vw;">
        <el-form-item>
          <el-button type="primary" :style="'background:'+SubmitBtnBgColor+'; border-color:'+SubmitBtnBgColor+';'" :disabled="btnDis" @click="onSubmit">{{SubmitBtnText}}</el-button>
        </el-form-item>
      </div>
      </el-form>


    </div>
    
    <div class="container33 theme-showcase" v-if="(btmimg != '' && btmimg != null)">
      <img :src="btmimg" style="max-width: 100%; display:block; margin:0 auto;" :style="BottomImgWidth==0?'width:100%;':('width:'+BottomImgWidth+'px;')"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'homeheader',
  data: function () {
    return {
      mode:0,
      cateId:0,
      countryCodes:[],
      countryCodes2:[],
      topimg: "",
      BottomImgWidth:0,
      topimgWidth:0,
      fieldlist: '',
      vallist: [],
      fieldval: [],
      fieldval2: [],
      fieldvalArr: [],
      imgsUrl: [],
      btmimg: '',
      checkList: [],
      btnDis: false,
      BgCss:'',
      FormWidth:0,
      FormMarginTop:0,
      FormMarginBtm:0,
      SubmitBtnText:'',
      SubmitBtnBgColor:'',
    }
  },
  computed: {
    datePickerOptions: vm => {
      return {
        disabledDate: time => {
          let index = vm.datepickerFocusIndex;// `${vm.datepickerFocusIndex}`;
          var fieldlist = vm.fieldlist;
          var field = fieldlist[index];
          if (field.MinValue != '' && field.MaxValue != '') {
            var minval = new Date('' + field.MinValue);

            var MaxValue = new Date('' + field.MaxValue);
            return (time.getTime() > MaxValue || time.getTime() < minval);
          } else
            if (field.MinValue != '') {
              var minval = new Date('' + field.MinValue);
              return time.getTime() < minval;
            } else
              if (field.MaxValue != '') {
                var MaxValue = new Date('' + field.MaxValue);
                return time.getTime() > MaxValue;
              } else {
                return false;
              }
        }
      }
    }
  },
  methods: {
    inputChange(index) {
      var val = this.vallist[index].val;
      var field = this.fieldlist[index];
      var fieldlist=this.fieldlist;
      console.log(val);
      if (field.TitleCapital) {
        val = val.slice(0, 1).toUpperCase() + val.slice(1);
      }
      if (field.Uppercase) {
        val = val.toUpperCase();
      }
      var vallist = this.vallist;
      var vitem = vallist[index];
      if (field.IsCompulsory) {
        if (val != '' && val.length > 0) {
          vitem.requiredErrMsg = '';
        }
        else {
          vitem.requiredErrMsg = field.RequiredFieldValidatorErrorMessage;
        }
      }

      {
      if(field.CompareFieldCode!='' && field.CompareFieldCode!=null && field.CompareFieldCode!=undefined){
        var cfd='';
        for(var i=0;i<fieldlist.length;i++){
          if(fieldlist[i].id == field.CompareFieldCode){
            cfd = fieldlist[i];
            if(field.CompareSign == '='){
              if(val!=this.vallist[i].val){
                vitem.requiredErrMsg = field.CompareErrorMessage;
              }else{
                vitem.requiredErrMsg = '';
              }
            }
            break;
          }
        }
      }
      else{
        for(var i=0;i<fieldlist.length;i++){
          if(fieldlist[i].CompareFieldCode == field.id){
            var citem = vallist[i];
            if(fieldlist[i].CompareSign == '='){
              if(val!=this.vallist[i].val){
                citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
              }else{
                citem.requiredErrMsg = '';
              }
              vallist.splice(i, 1, citem);
            }
            break;
          }
        }
      }
      }

      vitem.val = val;
      vallist.splice(index, 1, vitem);
      this.vallist = vallist;
    },
    inputOtherChange(index) {
      var val = this.vallist[index].otherVal;
      var field = this.fieldlist[index];
      console.log(val);
      if (field.ShowOther) {

        if (val != '' && val.length > 0) {

          var vallist = this.vallist;
          var vitem = vallist[index];
          vitem.requiredOtherErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;


        }
        else {
          var vallist = this.vallist;
          var vitem = vallist[index];
          vitem.requiredOtherErrMsg = "Required";// field.RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }
    },
    inputBlur(index) {
      var val = this.vallist[index].val;
      var field = this.fieldlist[index];
      console.log(val);
      if (val != '' && val.length > 0) {
        if (field.RegularExpressionValidatorValidationExpression != '') {
          var reg = new RegExp(field.RegularExpressionValidatorValidationExpression); ///^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;// 
          console.log(reg);
          if (!reg.test(val)) {
            var vallist = this.vallist;
            var vitem = vallist[index];
            vitem.requiredErrMsg = field.RegularExpressionValidatorErrorMessage;
            vallist.splice(index, 1, vitem);
            this.vallist = vallist;
          } else {
            var vallist = this.vallist;
            var vitem = vallist[index];
            vitem.requiredErrMsg = '';
            vallist.splice(index, 1, vitem);
            this.vallist = vallist;
          }
        }
      }
    },
    inputNumberChange(index) {
      var val = this.vallist[index].val;
      var field = this.fieldlist[index];
      var fieldlist= this.fieldlist;
      console.log(val);
          var vallist = this.vallist;
          var vitem = vallist[index];
      if (field.IsCompulsory) {
        if (val == 0 || val != '' && val != undefined && val != null) {
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }

      {
      if(field.CompareFieldCode!='' && field.CompareFieldCode!=null && field.CompareFieldCode!=undefined){
        var cfd='';
        for(var i=0;i<fieldlist.length;i++){
          if(fieldlist[i].id == field.CompareFieldCode){
            cfd = fieldlist[i];
            if(field.CompareSign == '='){
              if(val!=this.vallist[i].val){
                vitem.requiredErrMsg = field.CompareErrorMessage;
              }else{
                vitem.requiredErrMsg = '';
              }
            }else if(field.CompareSign == '>'){
              if(parseInt(val)>(parseInt(this.vallist[i].val)+parseInt(field.CompareDiff))){
                vitem.requiredErrMsg = '';
              }else{
                vitem.requiredErrMsg = field.CompareErrorMessage;
              }
            }else if(field.CompareSign == '<'){
              if(parseInt(val)+parseInt(field.CompareDiff)<(parseInt(this.vallist[i].val))){
                vitem.requiredErrMsg = '';
              }else{
                vitem.requiredErrMsg = field.CompareErrorMessage;
              }
            }
            break;
          }
        }
      }
      else{
        for(var i=0;i<fieldlist.length;i++){
          if(fieldlist[i].CompareFieldCode == field.id){
            var citem = vallist[i];
            if(fieldlist[i].CompareSign == '='){
              if(val!=this.vallist[i].val){
                citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
              }else{
                citem.requiredErrMsg = '';
              }
              vallist.splice(i, 1, citem);
            }else if(fieldlist[i].CompareSign == '>'){
              if((parseInt(val)+parseInt(fieldlist[i].CompareDiff))<(parseInt(this.vallist[i].val))){
                citem.requiredErrMsg = '';
              }else{
                citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
              }
            }else if(fieldlist[i].CompareSign == '<'){
              if((parseInt(val))>(parseInt(this.vallist[i].val)+parseInt(fieldlist[i].CompareDiff))){
                citem.requiredErrMsg = '';
              }else{
                citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
              }
            }
            break;
          }
        }
      }
      }

    },
    inputChange2(index) {
      var val = this.vallist[index].val;
      var val2 = this.vallist[index].val2;
      var field = this.fieldlist[index];
      console.log(val);
      if (field.IsCompulsory) {
        if (val != '' && val.length > 0 && val2 != '' && val2.length > 0) {
          var vallist = this.vallist;
          var vitem = vallist[index];
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          var vallist = this.vallist;
          var vitem = vallist[index];
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }
    },
    datepickerChange(index) {
      var val = this.vallist[index].val;
      var field = this.fieldlist[index];
      var fieldlist= this.fieldlist;
      var vallist = this.vallist;
          var vitem = vallist[index];
      console.log(val);
      if (field.IsCompulsory) {
        if (val != '' && val != undefined && val != null) {
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }

      {
        if (field.CompareFieldCode != '' && field.CompareFieldCode != null && field.CompareFieldCode != undefined) {
          var cfd = '';
          for (var i = 0; i < fieldlist.length; i++) {
            if (fieldlist[i].id == field.CompareFieldCode) {
              var dt1 = new Date(val);
              var dt2 = new Date(this.vallist[i].val);
              if (field.CompareSign == '=') {
                if (dt1 > dt2 || dt1<dt2) {
                  vitem.requiredErrMsg = field.CompareErrorMessage;
                } else {
                  vitem.requiredErrMsg = '';
                }
              }else if(field.CompareSign == '>'){
                var diff= field.CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==3){

                  var year = dt2.getFullYear()+parseInt(diffArr[0]);
                  var month = dt2.getMonth()+parseInt(diffArr[1])+1;
                  var day = dt2.getDate()+parseInt(diffArr[2]);
                  console.log(year+'-'+month+'-'+day);
                  var dt2 = new Date(year+'-'+month+'-'+day);
                  console.log(dt2);
                  if (dt1 > dt2) {
                    vitem.requiredErrMsg = '';
                  } else {
                    vitem.requiredErrMsg = field.CompareErrorMessage;
                  }
                  
                }
              }else if(field.CompareSign == '<'){
                var diff= field.CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==3){

                  var year = dt1.getFullYear()+parseInt(diffArr[0]);
                  var month = dt1.getMonth()+parseInt(diffArr[1])+1;
                  var day = dt1.getDate()+parseInt(diffArr[2]);
                  console.log(year+'-'+month+'-'+day);
                  var dt1 = new Date(year+'-'+month+'-'+day);
                  console.log(dt2);
                  if (dt1 < dt2) {
                    vitem.requiredErrMsg = '';
                  } else {
                    vitem.requiredErrMsg = field.CompareErrorMessage;
                  }
                  
                }
              }
              break;
            }
          }
        }
        else {
          for (var i = 0; i < fieldlist.length; i++) {
            if (fieldlist[i].CompareFieldCode == field.id) {
              var citem = vallist[i];
              var dt2 = new Date(val);
              var dt1 = new Date(this.vallist[i].val);
              if (fieldlist[i].CompareSign == '=') {
                if (dt1 > dt2 || dt1<dt2) {
                  citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
                } else {
                  citem.requiredErrMsg = '';
                }
              }else if(fieldlist[i].CompareSign == '>'){
                var diff= fieldlist[i].CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==3){

                  var year = dt2.getFullYear()+parseInt(diffArr[0]);
                  var month = dt2.getMonth()+parseInt(diffArr[1])+1;
                  var day = dt2.getDate()+parseInt(diffArr[2]);
                  console.log(year+'-'+month+'-'+day);
                  var dt2 = new Date(year+'-'+month+'-'+day);
                  console.log(dt2);
                  if (dt1 > dt2) {
                    citem.requiredErrMsg = '';
                  } else {
                    citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
                  }
                  
                }
              }else if(fieldlist[i].CompareSign == '<'){
                var diff= fieldlist[i].CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==3){

                  var year = dt1.getFullYear()+parseInt(diffArr[0]);
                  var month = dt1.getMonth()+parseInt(diffArr[1])+1;
                  var day = dt1.getDate()+parseInt(diffArr[2]);
                  console.log(year+'-'+month+'-'+day);
                  var dt1 = new Date(year+'-'+month+'-'+day);
                  console.log(dt1);
                  if (dt1 < dt2) {
                    citem.requiredErrMsg = '';
                  } else {
                    citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
                  }
                  
                }
              }
              vallist.splice(i, 1, citem);
              break;
            }
          }
        }
      }

    },

    datepickerFocus(index) {
      this.datepickerFocusIndex = index;
      console.log('datepickerFocusIndex:' + index);
    },

    timepickerChange(index) {
      var val = this.vallist[index].val;
      var field = this.fieldlist[index];
      var fieldlist = this.fieldlist;
          var vallist = this.vallist;
          var vitem = vallist[index];
      console.log(val);
      if (field.IsCompulsory) {
        if (val != '' && val != undefined && val != null) {
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }

      {
        if (field.CompareFieldCode != '' && field.CompareFieldCode != null && field.CompareFieldCode != undefined) {
          var cfd = '';
          for (var i = 0; i < fieldlist.length; i++) {
            if (fieldlist[i].id == field.CompareFieldCode) {
              var dt1 = val;
              var dt2 = this.vallist[i].val;
              if (field.CompareSign == '=') {
                if (dt1 != dt2) {
                  vitem.requiredErrMsg = field.CompareErrorMessage;
                } else {
                  vitem.requiredErrMsg = '';
                }
              }else if(field.CompareSign == '>'){
                var diff= field.CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==2){
                  var date1 = new Date('2022-02-02 '+dt1);
                  var date2 = (new Date('2022-02-02 '+dt2));
                  date2.setTime(date2.getTime()+parseInt(diffArr[0])*60*60*1000+parseInt(diffArr[1])*60*1000);
                  console.log(date2);
                  if (date1 > date2) {
                    vitem.requiredErrMsg = '';
                  } else {
                    vitem.requiredErrMsg = field.CompareErrorMessage;
                  }
                  
                }
              }else if(field.CompareSign == '<'){
                var diff= field.CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==2){
                  var date1 = new Date('2022-02-02 '+dt1);
                  var date2 = (new Date('2022-02-02 '+dt2));
                  date1.setTime(date1.getTime()+parseInt(diffArr[0])*60*60*1000+parseInt(diffArr[1])*60*1000);
                  if (date1 < date2) {
                    vitem.requiredErrMsg = '';
                  } else {
                    vitem.requiredErrMsg = field.CompareErrorMessage;
                  }
                  
                }
              }
              break;
            }
          }
        }
        else {
          for (var i = 0; i < fieldlist.length; i++) {
            if (fieldlist[i].CompareFieldCode == field.id) {
              var citem = vallist[i];
              var dt2 = (val);
              var dt1 = this.vallist[i].val;
              console.log(dt2,dt1);
              console.log(dt1 > dt2 || dt1<dt2);
              if (fieldlist[i].CompareSign == '=') {
                if (dt1 != dt2 ) {
                  citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
                } else {
                  citem.requiredErrMsg = '';
                }
              }else if(fieldlist[i].CompareSign == '>'){
                var diff= fieldlist[i].CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==2){
                  var date1 = new Date('2022-02-02 '+dt1);
                  var date2 = (new Date('2022-02-02 '+dt2));
                  date2.setTime(date2.getTime()+parseInt(diffArr[0])*60*60*1000+parseInt(diffArr[1])*60*1000);
                  if (date1 > date2) {
                    citem.requiredErrMsg = '';
                  } else {
                    citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
                  }
                  
                }
              }else if(fieldlist[i].CompareSign == '<'){
                var diff= fieldlist[i].CompareDiff;
                var diffArr = diff.split('|');
                if(diffArr.length ==2){
                  var date1 = new Date('2022-02-02 '+dt1);
                  var date2 = (new Date('2022-02-02 '+dt2));
                  date1.setTime(date1.getTime()+parseInt(diffArr[0])*60*60*1000+parseInt(diffArr[1])*60*1000);
                  if (date1 < date2) {
                    citem.requiredErrMsg = '';
                  } else {
                    citem.requiredErrMsg = fieldlist[i].CompareErrorMessage;
                  }
                  
                }
              }
              vallist.splice(i, 1, citem);
              break;
            }
          }
        }
      }

    },
    monthpickerChange(index) {
      var val = this.vallist[index].val;
      var field = this.fieldlist[index];
      console.log(val);
      if (field.IsCompulsory) {
        if (val != '' && val != undefined && val != null) {
          var vallist = this.vallist;
          var vitem = vallist[index];
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          var vallist = this.vallist;
          var vitem = vallist[index];
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }
    },
    countryFilterMethod(val) {
console.log(val);
// this.form.region1 = val //`这一步一定要加上，不然输入框会有问题`!!!!!
            if (val) {
                this.countryCodes = this.countryCodes2.filter((item) => {
                  var name = item.name.toUpperCase();
                  val = val.toUpperCase();
                    if (item.code.includes(val)||name.includes(val)) {
                        return true
                    }
                })
            }
            else {
                this.countryCodes = this.countryCodes2 //val为空时，还原数组
            }
},
SelectVisible(visi){ 
  if(visi){
this.countryCodes = this.countryCodes2;
  }
},
    selectChange(index) {
      var val = this.vallist[index].val;
      var fieldlist = this.fieldlist;
      var field = this.fieldlist[index];
      console.log(val);
      var vallist = this.vallist;
      var vitem = vallist[index];
      if (field.IsCompulsory) {
        if (val != '' && val.length > 0) {

          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }

      {
        if (field.ComboBoxOthersValue != '' && field.ComboBoxOthersValue != null) {

          console.log(field.ComboBoxOthersValue);
          if (val == field.ComboBoxOthersValue) {
            field.ShowOther = true;
          } else {
            field.ShowOther = false;
          }
          fieldlist.splice(index, 1, field);
          this.fieldlist = fieldlist;
        }
      }

      {
        for (var i = 0; i < vallist.length; i++) {
          var vfd = vallist[i];
          var fd = fieldlist[i];
          if (fd.VisibleDependFieldCode == field.id) {
            if (val.indexOf(fd.VisibleDependFieldValue)>=0) {
              vfd.showFd = true;
            } else {
              vfd.showFd = false;
            }
            vallist.splice(i, 1, vfd);
          }
          if (fd.CompulsoryDependFieldID == field.id) {
            if (val.indexOf(fd.CompulsoryDependFieldValue)>=0) {
              fd.IsCompulsory = true;
            } else {
              fd.IsCompulsory = false;
              vfd = vallist[i];
              vfd.requiredErrMsg='';
            }
            fieldlist.splice(i, 1, fd);
          }
        }
        this.fieldlist=fieldlist;
        this.vallist = vallist;
      }
    },
    selectMultipleChange(index) {
      var val = this.vallist[index].valArr;
      var fieldlist = this.fieldlist;
      var field = this.fieldlist[index];
      console.log(val);
          var vallist = this.vallist;
      if (field.IsCompulsory) {
        if (val != '' && val.length > 0) {
          var vitem = vallist[index];
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
        }
        else {
          var vitem = vallist[index];
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
        }
          this.vallist = vallist;
      }

      {
        console.log(field.ComboBoxOthersValue);
        if (val.indexOf(field.ComboBoxOthersValue) >= 0) {
          field.ShowOther = true;
        } else {
          field.ShowOther = false;
        }
        fieldlist.splice(index, 1, field);
        this.fieldlist = fieldlist;
      }

      {
        for (var i = 0; i < vallist.length; i++) {
          var vfd = vallist[i];
          var fd = fieldlist[i];
          if (fd.VisibleDependFieldCode == field.id) {
            if (val.indexOf(fd.VisibleDependFieldValue)>=0) {
              vfd.showFd = true;
            } else {
              vfd.showFd = false;
            }
            vallist.splice(i, 1, vfd);
          }
          if (fd.CompulsoryDependFieldID == field.id) {
            if (val.indexOf(fd.CompulsoryDependFieldValue)>=0) {
              fd.IsCompulsory = true;
            } else {
              fd.IsCompulsory = false;
              vfd = vallist[i];
              vfd.requiredErrMsg='';
            }
            fieldlist.splice(i, 1, fd);
          }
        }
        this.fieldlist=fieldlist;
        this.vallist = vallist;
      }

    },
    checkboxChange(index) {
      var val = this.vallist[index].valArr;
      var fieldlist = this.fieldlist;
      var field = this.fieldlist[index];
      console.log(val);
      console.log(val.length);
          var vallist = this.vallist;
      if (field.IsCompulsory) {
        if (val != [] && val.length > 0) {
          var vitem = vallist[index];
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
        }
        else {
          var vitem = vallist[index];
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
        }
          this.vallist = vallist;
      }

      {
        console.log(field.ComboBoxOthersValue);
        if (val.indexOf(field.ComboBoxOthersValue) >= 0) {
          field.ShowOther = true;
        } else {
          field.ShowOther = false;
        }
        fieldlist.splice(index, 1, field);
        this.fieldlist = fieldlist;
      }
      
      {
        for (var i = 0; i < vallist.length; i++) {
          var vfd = vallist[i];
          var fd = fieldlist[i];
          if (fd.VisibleDependFieldCode == field.id) {
            if (val.indexOf(fd.VisibleDependFieldValue)>=0) {
              vfd.showFd = true;
            } else {
              vfd.showFd = false;
            }
            vallist.splice(i, 1, vfd);
          }
          if (fd.CompulsoryDependFieldID == field.id) {
            if (val.indexOf(fd.CompulsoryDependFieldValue)>=0) {
              fd.IsCompulsory = true;
            } else {
              fd.IsCompulsory = false;
              vfd = vallist[i];
              vfd.requiredErrMsg='';
            }
            fieldlist.splice(i, 1, fd);
          }
        }
        this.fieldlist=fieldlist;
        this.vallist = vallist;
      }

    },
    radioChange(index) {
      var val = this.vallist[index].val;
      var fieldlist = this.fieldlist;
      var field = this.fieldlist[index];
      console.log(val);
      console.log(val.length);
      var vallist = this.vallist;
      if (field.IsCompulsory) {
        if (val != [] && val.length > 0) {
          var vitem = vallist[index];
          vitem.requiredErrMsg = '';
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
        else {
          var vitem = vallist[index];
          vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
          vallist.splice(index, 1, vitem);
          this.vallist = vallist;
        }
      }

      {
        console.log(field.ComboBoxOthersValue);
        if (val == field.ComboBoxOthersValue) {
          field.ShowOther = true;
        } else {
          field.ShowOther = false;
        }
        fieldlist.splice(index, 1, field);
        this.fieldlist = fieldlist;
      }
      {
        for (var i = 0; i < vallist.length; i++) {
          var vfd = vallist[i];
          var fd = fieldlist[i];
          if (fd.VisibleDependFieldCode == field.id) {
            if (val == fd.VisibleDependFieldValue) {
              vfd.showFd = true;
            } else {
              vfd.showFd = false;
            }
            vallist.splice(i, 1, vfd);
          }
          if (fd.CompulsoryDependFieldID == field.id) {
            if (val.indexOf(fd.CompulsoryDependFieldValue)>=0) {
              fd.IsCompulsory = true;
            } else {
              fd.IsCompulsory = false;
              vfd = vallist[i];
              vfd.requiredErrMsg='';
            }
            fieldlist.splice(i, 1, fd);
          }
        }
        this.fieldlist=fieldlist;
        this.vallist = vallist;
      }

    },

    onSubmit() {
      var vallist = this.vallist;
      var fieldlist = this.fieldlist;
      for (var i = 0; i < vallist.length; i++) {
        var item = vallist[i];
        var field = fieldlist[i];
        if (field.IsCompulsory) {
          if (field.FieldTypeID != 10) {
            if ((item.val == '' || item.val == null || item.val == undefined) && (item.val2 == '' || item.val2 == null || item.val2 == undefined) && (item.imgUrl == '' || item.imgUrl == null || item.imgUrl == undefined) && (item.valArr == '' || item.valArr == null || item.valArr == undefined || item.valArr == [])) {
              item.requiredErrMsg = field.RequiredFieldValidatorErrorMessage;
            } else {
              console.log(field.RegularExpressionValidatorValidationExpression);
              if (field.RegularExpressionValidatorValidationExpression != '') {
              } else {
                // item.requiredErrMsg = '';
              }

            }
          }
        }
        if (field.ShowOther && (item.otherVal == '' || item.otherVal == null || item.otherVal == undefined)) {
          item.requiredOtherErrMsg = 'Required';
          console.log('Required');
        } else {
          // item.requiredOtherErrMsg = '';
        }
      }

      for (var i = 0; i < vallist.length; i++) {
        var item = vallist[i];
        var field = fieldlist[i];
        if (field.IsCompulsory != true) {
          if (field.FieldTypeID != 10) {

            if (field.RegularExpressionValidatorValidationExpression != '') {
              if ((item.val == '' || item.val == null || item.val == undefined) && (item.val2 == '' || item.val2 == null || item.val2 == undefined) && (item.imgUrl == '' || item.imgUrl == null || item.imgUrl == undefined) && (item.valArr == '' || item.valArr == null || item.valArr == undefined || item.valArr == [])) {

                // item.requiredErrMsg = '';
              } else {
                var reg = new RegExp(field.RegularExpressionValidatorValidationExpression); ///^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;// 
                console.log(reg);
                if (!reg.test(item)) {
                  item.requiredErrMsg = field.RegularExpressionValidatorErrorMessage;
                } else {
                  // item.requiredErrMsg = '';
                }
              }
            } else {
              // item.requiredErrMsg = '';
            }

          }
        }
      }

      console.log(vallist);
      console.log(fieldlist);
      for(var i=0;i<vallist.length;i++){
        if(vallist[i].requiredErrMsg!=''){
          console.log("验证失败");
          return;
        }
      }

      this.saveFields();

    },

    saveFields(){
            this.loading = true;
            this.btnDis= true;
            
            var uid ='';
            var token ='';
            axios.post('api/Fields/saveFieldVal',
                {
                    uid: uid,
                    token: token,
                    id:this.id,
                    eventId:this.eventId,
                    cateId:this.cateid,
                    vallist:this.vallist,
                    fdlist:this.fieldlist
                }
            )
                .then(this.saveFieldsSucc)
        },
        saveFieldsSucc(res) {
      this.loading = false;
      res = res.data;
      console.log(res);
      if (res && res.Code == 200) {
          this.no = res.preRegNo;
        if(this.mode == 2){
        this.$router.replace('/payment?id=' + this.id + "&cate=" + this.cateid + "&no=" + this.no);
        }else{
        this.$message({
          message: 'Success!',
          type: 'success',
          onClose: () => {

          }
        });
        this.$router.replace('/regfinish?id=' + this.id + "&cate=" + this.cateid + "&no=" + this.no);
        }
      } else {
        if (res && res.Code == 301) {
          localStorage.removeItem('userJson');
          this.$router.replace('/login');
        }
      }
    },

    imgUpload(data) {
      console.log(data);
      var index = data.data.index;
      var formData = new FormData();
      formData.append("file", data.file);
      
      axios.post('api/UploadFile/VisitorUpLoadOneImg?type=210',
        formData
      )
        .then((res) => {
          res = res.data
          console.log(res);
          if (res && res.Code == 200) {

            var vallist = this.vallist;
            var vitem = vallist[index];
            vitem.imgUrl = res.fileUrl;
            vitem.requiredErrMsg = '';
            vallist.splice(index, 1, vitem);
            this.vallist = vallist;

          }
        })
    },

    delimg(index) {
      var vallist = this.vallist;
      var vitem = vallist[index];
      var field = this.fieldlist[index];
      vitem.imgUrl = '';
      if (field.IsCompulsory) {
        vitem.requiredErrMsg = this.fieldlist[index].RequiredFieldValidatorErrorMessage;
      }
      vallist.splice(index, 1, vitem);
      this.vallist = vallist;
    },

    loadEvent() {
      this.loading = true;
      axios.post('/api/event/getOne?code=' + this.id,
        {
          code: this.id
        }
      )
        .then(this.loadDataSucc)
    },
    loadDataSucc(res) {
      this.loading = false;
      res = res.data
      console.log(res);
      if (res && res.Code == 200) {
        var item = res;
        console.log(item);
        this.id = item.eventCode,
        this.eventId = item.id,
        this.BgCss = item.BgCss,  
      this.FormWidth=item.FormWidth,
      this.FormMarginTop=item.FormMarginTop,
      this.FormMarginBtm=item.FormMarginBtm,
      this.SubmitBtnText=item.SubmitBtnText,
      this.SubmitBtnBgColor=item.SubmitBtnBgColor,

          this.eventname = item.eventName,
          this.address = item.address,
          this.eventstartdate = item.beginDT,
          this.eventenddate = item.endDt,
          this.endtxt = item.endTxt,
          this.finishtext = item.finishTxt,
          this.agreement = item.agreement,
          this.topimg = item.topimgUrl,
          this.topimgWidth = item.TopImgWidth,
          this.BottomImgWidth=item.BottomImgWidth,
          this.btmimg = item.bottomImgUrl,
          this.canbeedit = item.userCanEdit,
          this.dateformat = item.DateFormat,
          this.fieldDefDisplayType = item.FieldDefDisplayType
        this.catelist = item.catelist;
          console.log(this.cateid + ":2cateid")
        if (this.cateid == 0 || this.cateid == undefined) {
          var cateid = 0;
          for (var i = 0; i < item.catelist.length; i++) {
            if (item.catelist[i].isDefault == 'True') {
              cateid = item.catelist[i].id;
            }
          }
          this.cateid = cateid;
          if(cateid == 0){
          this.$router.replace('/selectcate?id='+item.id);
          }
          console.log(cateid + ":cateid")
        }else{
          for(var i =0; i<item.catelist.length;i++){
            if (item.catelist[i].id == this.cateid) {
              if(item.catelist[i].payment){
                this.mode = 2;
              }else{
                this.mode=1;
              }
            }
          }
        }
        this.loadFields();
      } else {
        if (res && res.Code == 301) {
          localStorage.removeItem('userJson');
          this.$router.replace('/login');
        }
      }
    },

    loadFields() {
      this.loading = true;
      var eventId = this.eventId;
      console.log(eventId);
      axios.post('/api/Fields/getFieldsList',
        {
          eventId: eventId,
          usertype: 12,
        }
      )
        .then(this.loadFieldsSucc)
    },
    loadFieldsSucc(res) {
      this.loading = false;
      res = res.data
      console.log(res);
      if (res && res.Code == 200) {
        var fieldlist = res.list;
        for (var i = 0; i < fieldlist.length; i++) {
          var field = fieldlist[i];

          if (field.FieldTypeID == 7) {

          } else {
            if (field.MinValue != '') {
              fieldlist[i].MinValue = parseInt(field.MinValue);
            } else {
              fieldlist[i].MinValue = -Infinity;
            }
            if (field.MaxValue != '') {
              fieldlist[i].MaxValue = parseInt(field.MaxValue);
            } else {
              fieldlist[i].MaxValue = Infinity;
            }
          }
          if (res.list[i].FieldTypeID != 13) {
            if (fieldlist[i].MaxLength == null || fieldlist[i].MaxLength < 1) {
              fieldlist[i].MaxLength = '99999';
            }
          }

        }
        this.fieldlist = fieldlist;

        var fieldval = [];
        var fieldval2 = [];
        var imgsUrl = [];
        var fieldvalArr = [];
        var vallist = [];
        for (var i = 0; i < res.list.length; i++) {
          fieldval.push("");
          fieldval2.push("");
          imgsUrl.push("");
          fieldvalArr.push([]);
          var val = '';
          var showFd = true;
          var halfWidth=false;
          if (fieldlist[i].VisibleDependFieldCode != null && fieldlist[i].VisibleDependFieldCode != '') {
            showFd = false;
          }

          if ((i<res.list.length-1) && i>0) {
            console.log(fieldlist[i])
            if((fieldlist[i].DisplaySameLineAfterPreFd == true || fieldlist[i-1].DisplaySameLineAfterPreFd == true)){
            halfWidth = true; 
            }
          }else if(i==0){
            if((fieldlist[i].DisplaySameLineAfterPreFd == true || fieldlist[i+1].DisplaySameLineAfterPreFd == true)){
            halfWidth = true; 
            }
          }else{
            if((fieldlist[i].DisplaySameLineAfterPreFd == true)){
            halfWidth = true; 
            }
          }

          vallist.push({fdId:fieldlist[i].id, val: val, val2: '', imgUrl: '', valArr: [], otherVal: '', requiredErrMsg: '', requiredOtherErrMsg: '', showFd: showFd, halfWidth:halfWidth });
        }
        this.fieldval = fieldval;
        this.fieldval = fieldval2;
        this.fieldval = imgsUrl;
        this.fieldvalArr = fieldvalArr;
        this.vallist = vallist;
        this.countryCodes = res.countryCodes;
        this.countryCodes2=res.countryCodes;
      } else {
        if (res && res.Code == 301) {
          localStorage.removeItem('userJson');
          this.$router.replace('/login');
        }
      }
    },
    trackEvent() {
      this.$gtm.trackEvent({
        event: 'PreReg',
        category: 'PreReg',
        action: 'PreReg',
        label: 'PreReg',
        value: 1,
      });
    },
  },
  mounted() {
    const id = this.$route.query.id;
    const cate = this.$route.query.cid;
    this.id = id;
    this.cateid=cate;
    console.log(cate);
    this.loadEvent();

    this.trackEvent();
  }
}
</script>
<style lang="stylus" scoped>
.container33{
  margin:0 auto;
}
.container11{
  background:#fff;
  margin:auto;
  max-width:100%;
}


.fieldLabel{
  font-size: 18px;
  margin: 16px 0;
}
.otherFieldLabel{
  margin-top:-26px;
}

/deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }
  /deep/ input[type="number"] {
      -moz-appearance: textfield;
  }
  /deep/ inpit {
      border: none
  }

  
.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
}

.avatar {
    width: 128px;
    display: block;
}

.elCheckboxItem{
  width:calc(100% - 16px);
  display:inline-block;
  padding-right:16px;
}
.elRadioItem{
  width:calc(100% - 16px);
  display:inline-block;
  padding-right:16px;
}

.elCheckboxItem2{
  width:calc(50% - 16px);
}
.elRadioItem2{
  width:calc(50% - 16px);
}

.elCheckboxItem3{
  width:calc(33.3% - 16px);
}
.elRadioItem3{
  width:calc(33.3% - 16px);
}

.elCheckboxItem4{
  width:calc(25% - 16px);
}
.elRadioItem4{
  width:calc(25% - 16px);
}

.fdItem{
  display:inline-block;
  width:calc(100% - 8vw);
  vertical-align: top;

  margin:12px 4vw;
}
.fdItem2{
  width:calc(50% - 4vw);
  margin:12px 0vw 12px 4vw;
}

</style>



// WEBPACK FOOTER //
// src/pages/home/components/header.vue